// extracted by mini-css-extract-plugin
module.exports = {"floatSearch":"FloatSearch_floatSearch__2PdW2","close":"FloatSearch_close__cqbL2","innerDiv":"FloatSearch_innerDiv__1MBIi","contentLink":"FloatSearch_contentLink__lG72Y"};